import {useSearchParams} from 'next/navigation';

const FILTER_BY_PARAM = 'filterBy';
const SORT_BY_PARAM = 'sortBy';
export const useFilters = () => {
  const currentParams = useSearchParams();

  const searchParams = new URLSearchParams(currentParams.toString());

  return {
    getFullValue: () =>
      `${searchParams?.size ? `?${searchParams.toString()}` : ''}`,
    filterBy: {
      get: () => searchParams.get(FILTER_BY_PARAM),
      set: (value: string | null) => {
        if (value !== null) {
          searchParams.set(FILTER_BY_PARAM, value);
        } else {
          searchParams.delete(FILTER_BY_PARAM);
        }
      },
    },
    sortBy: {
      get: () => searchParams.get(SORT_BY_PARAM),
      set: (value: string | null) => {
        if (value !== null) {
          searchParams.set(SORT_BY_PARAM, value);
        } else {
          searchParams.delete(SORT_BY_PARAM);
        }
      },
    },
  };
};
